import { RfqStatus } from '@luminovo/api-contracts';

export const nonArchivableRfqStatuses: RfqStatus[] = [RfqStatus.RequestInDraft, RfqStatus.QuotationInProgress];

export const isRfqArchivable = (status: RfqStatus): boolean => !nonArchivableRfqStatuses.includes(status);
